import TransferMediaContainer from './TransferMediaContainer.vue'
import UContainer from './UContainer.vue'
import UFilesList from './UFilesList.vue'
import UFileItem from './UFileItem.vue'
import DContainer from './DContainer.vue'
import DFilesList from './DFilesList.vue'
import DFileItem from './DFileItem.vue'

export default {
  [TransferMediaContainer.name]: TransferMediaContainer,
  [UContainer.name]: UContainer,
  [UFilesList.name]: UFilesList,
  [UFileItem.name]: UFileItem,
  [DContainer.name]: DContainer,
  [DFilesList.name]: DFilesList,
  [DFileItem.name]: DFileItem
}



// WEBPACK FOOTER //
// ./src/plugins/uploader/components/index.js